import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  logoVariant: 'full',
  brandClasses: {
    logo: 'h-5 lg:h-6.5 md:h-6',
    totalItems: 'bg-grey-10',
    utilityNavigation: 'gap-4 pb-7 pt-2'
  },
  promoBarHeight: {
    sm: '2rem',
    lg: '1.625rem'
  }
} satisfies RecursivePartial<VfConfig['header']>
